// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nhtml,\nbody,\n#app {\n width: 100%;\n /* height: 100%; */\n margin-left: 0px;\n margin-right: 0px;\n margin-top: 0px;\n margin-bottom: 0px;\n padding-left: 0px;\n padding-right: 0px;\n padding-top: 0px;\n padding-bottom: 0px;\n}\n#app {\n flex: 1;\n}\n", ""]);
// Exports
module.exports = exports;
